import { useEffect } from "react";

const SITE_URL = "https://www.innospeq.com";
const DEFAULT_DESCRIPTION =
  "Innospeq digitalisiert und automatisiert Sicherheitsbegehungen durch KI-gestützte Analyse von Arbeitsumgebungen. Schneller. Strukturierter. Revisionssicher.";

const routeMetadata = {
  "/": {
    title: "Innospeq · KI-gestützte Sicherheitsbegehungen",
    description: DEFAULT_DESCRIPTION,
  },
  "/about": {
    title: "Über uns · Innospeq",
    description:
      "Lernen Sie das Team und die Vision hinter Innospeq kennen – der KI-gestützten Plattform für effizientere Sicherheitsbegehungen.",
  },
  "/pricing": {
    title: "Preise · Innospeq",
    description:
      "Entdecken Sie die Innospeq Tarife für digitale, KI-gestützte Sicherheitsbegehungen und transparentes Maßnahmenmanagement.",
  },
  "/disclaimer": {
    title: "Haftungsausschluss · Innospeq",
    description: "Haftungsausschluss für die Nutzung der Innospeq Plattform.",
  },
  "/imprint": {
    title: "Impressum · Innospeq",
    description: "Impressum und Anbieterkennzeichnung von Innospeq.",
  },
  "/privacy": {
    title: "Datenschutz · Innospeq",
    description: "Datenschutzerklärung von Innospeq.",
  },
};

function upsertMeta(name, content) {
  let element = document.head.querySelector(`meta[name="${name}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("name", name);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}
function upsertCanonical(href) {
  let element = document.head.querySelector('link[rel="canonical"]');
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
}

export function Seo({ pathname, noindex = false }) {
  useEffect(() => {
    const metadata = routeMetadata[pathname] || {
      title: "Seite nicht gefunden · Innospeq",
      description: DEFAULT_DESCRIPTION,
    };
    const canonicalPath = routeMetadata[pathname] ? pathname : "/";

    document.title = metadata.title;
    upsertMeta("description", metadata.description);
    upsertMeta("robots", noindex ? "noindex, nofollow" : "index, follow");
    upsertCanonical(`${SITE_URL}${canonicalPath}`);
  }, [noindex, pathname]);

  return null;
}
